module.exports = __webpack_public_path__ + "img/logo.3c6ea8d2.png";